export default function OnboardingScreen2() {
  return (
    <div className="l2f-ob-screen">
      <div className="l2f-ob-eyebrow">02 · WHAT WE DO</div>
      <h1 className="l2f-ob-headline">
        Send us any outfit. We tell you if it's worth buying.
      </h1>
      <p className="l2f-ob-body">
        A link, a screenshot, a photo from Instagram — we read the fit, the
        fabric, and how it maps to your body.
      </p>
      <div className="l2f-ob-visual" aria-hidden>
        <div className="l2f-ob-card-stack">
          <div className="l2f-ob-mini-card">link</div>
          <div className="l2f-ob-mini-card">screenshot</div>
          <div className="l2f-ob-mini-card">photo</div>
        </div>
      </div>
    </div>
  );
}
